export const formatSearchText = (searchText: string) =>
  searchText.replace(/\s+/g, ' ').trim();
